(() => {
  const sectionSelector = '.dartsrx-benefits';
  const cardSelector = '.dartsrx-benefit-card';

  document.addEventListener('toggle', (event) => {
    const activeCard = event.target;
    if (!activeCard.matches(cardSelector) || !activeCard.open) return;

    const section = activeCard.closest(sectionSelector);
    if (!section) return;

    section.querySelectorAll(cardSelector).forEach((card) => {
      if (card !== activeCard) card.open = false;
    });
  }, true);
})();
